import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { Router } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UserSettingsService } from './../user-settings.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from 'underscore';
import * as $ from 'jquery';
@Component({
  selector: 'app-plan-history-details',
  templateUrl: './plan-history-details.component.html',
  styleUrls: ['./plan-history-details.component.css'],
})
export class PlanHistoryDetailsComponent implements OnInit, AfterViewInit {
  url = environment.api_url;
  selectedAddress;
  hg_accountId;
  name;
  energyPlanObj;
  userObj;
  maxAveragePriceObj;
  maxMonthlyBillObj;
  maxAveragePrice;
  maxMonthlyBill;
  math = Math;
  addressModalVisible = false;
  chanedAddress;
  selectedESIID;
  selectedAddressList = [];
  deviceHeight;
  selectedProductLogos = {
    ChariotEnergy: 'Chariot Energy Logo',
    PulsePower: 'Pulse Power Logo',
  };
  showSingleObjDetails: boolean;
  showFilters: boolean;
  constructor(
    private router: Router,
    private userSettingsService: UserSettingsService,
    private http: HttpClient,
    private residentialService: ResidentialService
    
  ) {
    // this.name = this.userSettingsService.userName ? this.userSettingsService.userName : 'Sam';
    this.deviceHeight = window.innerHeight;
  }

  showAddressModal() {
    this.addressModalVisible = true;
    this.residentialService.setSelectedAddress(this.selectedAddress);
  }

  submit() {
    this.addressModalVisible = false;
    $('.modal-backdrop').css('display', 'none');
    $('body').css('padding-right', '0');
    const body = new HttpParams();

    this.residentialService.selectAddress = this.selectedAddress;
    this.residentialService.selectESIID = this.selectedESIID;
    this.router.navigate([
      'user-settings/plan-history-details',
      this.hg_accountId,
    ]);
  }

  getAddress(event,essid) {
    this.selectedAddress = event;

    this.chanedAddress =
      this.selectedAddress.street_address +
      ',' +
      this.selectedAddress.city +
      ',' +
      this.selectedAddress.state +
      ',' +
      this.selectedAddress.zipcode;

      this.selectedESIID = essid;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    var height = Number(this.deviceHeight) - 110;
    $('.sidenav').height(height);
    this.userSettingsService.getUserObj.subscribe((data) => {
      if (data['userObj']) {
        this.userObj = data['userObj'].user;
        this.name = this.userObj.fName + ' ' + this.userObj.lName;
      }
    });
    this.hg_accountId = window.location.href.split('/').pop();
    this.selectedAddress = this.residentialService.selectAddress;
    this.selectedESIID = this.residentialService.selectESIID;
    this.selectedAddress = JSON.stringify(this.selectedAddress);
    const body = new HttpParams()
    .append('selectedAddress', this.selectedAddress)
    .append('hg_accountId', this.hg_accountId)
    .append('esiid', this.selectedESIID);
    this.http
      .get(this.url + '/getSelectedPlanHistory', { params: body })
      .subscribe((res: any) => {
        const result = res;
        this.energyPlanObj = result;
        this.chanedAddress =
          this.energyPlanObj[0].billingAddress.userAddress.street_address +
          ',' +
          this.energyPlanObj[0].billingAddress.userAddress.city +
          ',' +
          this.energyPlanObj[0].billingAddress.userAddress.state +
          ',' +
          this.energyPlanObj[0].billingAddress.userAddress.zipcode;
      });

    this.selectedAddress = this.residentialService.selectAddress;
    
    // To get the enrollment details for the selected address
    const body1 = new HttpParams()
    .append('selectedAddress', this.selectedAddress)
    .append('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getPlanHistory', { params: body1 })
      .subscribe((res: any) => {
        const resAddress = res;
        this.selectedAddressList = _.uniq(
          resAddress.addressList,
          function (address) {
            let newad = address.billingAddress.billingAddress.billingAddress;
           
            return (address.billingAddress.userAddress1 =
              newad.street_address +
              ',' +
              (address.billingAddress.apartment == "" ? "" : address.billingAddress.apartment + ", ") 
              +
              newad.city +
              ',' +
              newad.state +
              ',' +
              newad.zipcode);
          }
        );
        
        console.log('length..', this.selectedAddressList.length);
      });
  }

  selectedProductLogo(singleObj) {
    return this.selectedProductLogos[
      singleObj.selectedProduct.energy_provider.replace(/\s/g, '')
    ];
  }
  ngAfterViewInit(): void {
    this.maxAveragePriceObj = _.max(this.energyPlanObj, function (stooge) {
      return stooge.selectedProduct.new_tier.ave_price_per_KWH;
    });
    this.maxMonthlyBillObj = _.max(this.energyPlanObj, function (stooge) {
      return stooge.selectedProduct.new_tier.ave_monthly_bill;
    });
    this.maxAveragePrice = (
      Number(
        this.maxAveragePriceObj.selectedProduct.new_tier.ave_price_per_KWH
      ) * 100
    ).toFixed(1);
    this.maxMonthlyBill =
      this.maxMonthlyBillObj.selectedProduct.new_tier.ave_monthly_bill.toFixed(
        1
      );
    const avgElements = document.getElementsByClassName('avgvalue');

    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (this.maxAveragePrice || this.maxMonthlyBill) {
          if (
            this.maxAveragePrice.length >= 9 ||
            this.maxMonthlyBill.length >= 9
          ) {
            avgElements[i].classList.add('avgpricelen28');
          } else if (
            this.maxAveragePrice.length === 8 ||
            this.maxMonthlyBill.length === 8
          ) {
            avgElements[i].classList.add('avgpricelen31');
          } else if (
            this.maxAveragePrice.length === 7 ||
            this.maxMonthlyBill.length === 7
          ) {
            avgElements[i].classList.add('avgpricelen36');
          } else if (
            this.maxAveragePrice.length === 6 ||
            this.maxMonthlyBill.length === 6
          ) {
            avgElements[i].classList.add('avgpricelen42');
          } else if (
            this.maxAveragePrice.length <= 5 ||
            this.maxMonthlyBill.length <= 5
          ) {
            avgElements[i].classList.add('avgpricelen48');
          }
        }
      }
    }
  }
  back() {
    this.router.navigate(['user-settings', this.hg_accountId]);
  }
  
  isDate(date) {
   
    return Date.parse(date).toString() == "NaN" ? false : true
    
    
    }

    showSingleObjFilterCard() {
      this.showSingleObjDetails = !this.showSingleObjDetails;
      this.showFilters = false;
    }
    SelectAddressfunction(e)
    {
      $("#" + e).trigger('click')
    }
  
  
}
